import api from './api'

export const customerService = {
  getAll: (params?: { search?: string; group?: string; page?: number; limit?: number }) =>
    api.get('/customers', { params }),

  getGroups: () =>
    api.get('/customers/groups'),

  getById: (id: number | string) =>
    api.get(`/customers/${id}`),

  getPurchaseHistory: (id: number | string, params?: { page?: number; limit?: number }) =>
    api.get(`/customers/${id}/purchase-history`, { params }),

  getPOSHistory: (id: number | string) =>
    api.get(`/customers/${id}/pos-history`),

  create: (data: any) =>
    api.post('/customers', data),

  update: (id: number | string, data: any) =>
    api.put(`/customers/${id}`, data),

  delete: (id: number | string) =>
    api.delete(`/customers/${id}`),

  importStatement: (id: number | string, entries: any[]) =>
    api.post(`/customers/${id}/import-statement`, { entries }),
}
